var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-3 bg-gray-50 text-right sm:px-6"},[_c('div',{staticClass:"w-full bg-gray-200 rounded-full"},[_c('div',{staticClass:"h-2 bg-indigo-600 rounded-full",style:({ width: _vm.progressPercentage })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }